import JournalMarche from 'JournalMarche';
import UserProfile from 'UserProfile';

function handlingRequest() {
    const { fetch: origFetch, open: origOpen } = window;

    window.open = function(url, name, features, replace) {
        url = url.split('?');
        url =
            url[0] +
            ((url.length - 1 > 0 ? '?' + url[1] + '&' : '?') + 'token=' + UserProfile.getToken());
        origOpen(url, name, features, replace);
    };

    window.fetch = async (...args) => {
        if (args.length > 1) {
            if (args[1].method == 'GET') {
                let url = args[0].split('?');
                args[0] =
                    args[0] +
                    ((url.length - 1 > 0 ? '&' : '?') + 'token=' + UserProfile.getToken());
            } else if (args[1].body instanceof FormData) {
                args[1].body.append('token', UserProfile.getToken());
            } else if (typeof args[1].body === 'string') {
                let url = args[0].split('?');
                args[0] =
                    args[0] +
                    ((url.length - 1 > 0 ? '&' : '?') + 'token=' + UserProfile.getToken());
                // Assume JSON string body
                try {
                    const parsed = JSON.parse(args[1].body);
                    parsed.token = UserProfile.getToken();
                    args[1].body = JSON.stringify(parsed);
                } catch (e) {
                    console.error(e)
                }
            } else {
                // No body, or some other type — send token as query param
                let url = args[0].split('?');
                args[0] =
                    args[0] +
                    ((url.length - 1 > 0 ? '&' : '?') + 'token=' + UserProfile.getToken());
            }
        } else {
            let url = args[0].split('?');
            args[0] =
                args[0] + ((url.length - 1 > 0 ? '&' : '?') + 'token=' + UserProfile.getToken());
        }

        const response = await origFetch(...args);

        if (response.status >= 200 && response.status <= 399) {
            return response;
        }

        return response.text().then(err => {
            if (response.status === 403) {
                UserProfile.clearSession();
                JournalMarche.clearSession();

                window.location.replace(`${window.location.origin}/sign-in`);
                return [];
            }
            throw Error(err);
        });
    };
}

export default { handlingRequest };
